import {
  LayoutGrid,
  GanttChart,
  Columns,
  Kanban,
  Calendar,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { ViewMode } from '@/stores/useViewStore';

interface ViewModeSelectorProps {
  currentMode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
  className?: string;
}

const viewModes: {
  mode: ViewMode;
  icon: typeof LayoutGrid;
  label: string;
  shortcut?: string;
}[] = [
  { mode: 'grid', icon: LayoutGrid, label: 'Grid View', shortcut: 'G' },
  { mode: 'gantt', icon: GanttChart, label: 'Gantt View', shortcut: 'T' },
  { mode: 'split', icon: Columns, label: 'Split View', shortcut: 'S' },
  { mode: 'card', icon: Kanban, label: 'Card View', shortcut: 'K' },
  { mode: 'calendar', icon: Calendar, label: 'Calendar View', shortcut: 'C' },
];

export function ViewModeSelector({
  currentMode,
  onModeChange,
  className,
}: ViewModeSelectorProps) {
  return (
    <div className={cn('flex items-center rounded-md border bg-muted p-0.5', className)}>
      {viewModes.map(({ mode, icon: Icon, label, shortcut }) => (
        <Tooltip key={mode}>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className={cn(
                'h-7 w-7 p-0',
                currentMode === mode && 'bg-background shadow-sm'
              )}
              onClick={() => onModeChange(mode)}
            >
              <Icon className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            {label}
            {shortcut && (
              <span className="ml-2 text-muted-foreground">({shortcut})</span>
            )}
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}

export default ViewModeSelector;
